import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  // Chip,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

const styles = {
  inputWrapper: {
    margin: "0.5rem 1rem",
  },
  submit: {
    textAlign: "center",
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
  },

  // emailChipsContainer: {
  //   display: "flex",
  //   flexWrap: "wrap",
  //   gap: "0.5rem",
  //   marginTop: "0.5rem",
  // },
};

// // Función para validar formato de correo electrónico
// const isValidEmail = (email) => {
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   return emailRegex.test(email.trim());
// };

// // Función para procesar y validar correos secundarios
// const getValidEmails = (emailsString) => {
//   if (!emailsString || emailsString.trim() === "") return [];

//   return emailsString
//     .split(",")
//     .map((email) => email.trim())
//     .filter((email) => email !== "" && isValidEmail(email));
// };

const InvestorDetailsCard = (props) => {
  // const validEmails = getValidEmails(props.secondaryEmails);
  // const allEmails = props.secondaryEmails
  //   ? props.secondaryEmails
  //       .split(",")
  //       .map((e) => e.trim())
  //       .filter((e) => e !== "")
  //   : [];
  // const hasInvalidEmails = allEmails.length > validEmails.length;

  return (
    <Card>
      <CardHeader title="Datos del inversionista" />
      <CardContent>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h5">Info de contacto</Typography>
            <Box sx={styles.inputWrapper}>
              <TextField
                label="Nombre"
                name="name"
                value={props.name}
                onChange={props.onChange}
              />
            </Box>
            <Box sx={styles.inputWrapper}>
              <TextField
                label="Correo"
                name="email"
                value={props.email}
                onChange={props.onChange}
              />
            </Box>
            <Box sx={styles.inputWrapper}>
              <TextField
                label="Teléfono"
                name="phoneNumber"
                value={props.phoneNumber}
                onChange={props.onChange}
              />
            </Box>
            <Box sx={styles.inputWrapper}>
              <TextField
                label="Otros"
                name="other"
                multiline
                rows={3}
                value={props.other}
                onChange={props.onChange}
              />
            </Box>
            {/* <Box sx={styles.inputWrapper}>
              <TextField
                label="Correos secundarios (separados por coma)"
                name="secondaryEmails"
                multiline
                rows={1}
                value={props.secondaryEmails}
                onChange={props.onChange}
                placeholder="ejemplo1@correo.com, ejemplo2@correo.com"
                helperText={
                  hasInvalidEmails
                    ? "Algunos correos no son válidos"
                    : "Ingrese múltiples correos separados por comas"
                }
                error={hasInvalidEmails}
              />
              {validEmails.length > 0 && (
                <Box sx={styles.emailChipsContainer}>
                  {validEmails.map((email, index) => (
                    <Chip
                      key={index}
                      label={email}
                      color="primary"
                      variant="outlined"
                      size="small"
                    />
                  ))}
                </Box>
              )}
            </Box> */}
          </Grid>
          <Grid item xs={12}>
            <Box sx={styles.submit}>
              <Button onClick={props.onSubmit}>Guardar</Button>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default InvestorDetailsCard;
